import m from 'moment';
import 'moment-precise-range-plugin';
import { browserHistory } from 'react-router';

export const EVENT_CARD_FORMAT_TIME_EPG = 'YYYY/MM/DD HH:mm:ss';
export const DATE_FORMAT_START_SCHEDULE = 'YYYY/MM/DD HH:00:00';
export const DATE_FORMAT_START_RANGE = 'YYYY/MM/DD 00:00:00';
export const DATE_FORMAT_BEFORE_30_MINUTES = 'YYYYMMDDHH0000';
export const DATE_FORMAT_AFTER_30_MINUTES = 'YYYYMMDDHH3000';
export const EVENT_CARD_FORMAT_TIME = 'YYYYMMDD000000';
export const DATE_FORMAT_START_SCHEDULE_MIN = 'YYYYMMDDHHmm00';
export const HOUR_FORMAT_EPG = 'HH.mm';

export const chunkSchedule = (maxTimeshift = 0, initialSchedule) => {
  const dateFrom = m(
    initialSchedule,
    DATE_FORMAT_START_SCHEDULE_MIN,
    true,
  ).format('HH.mm');

  const schedule = [`${dateFrom}hs.`];
  let i = 0;
  const oneDay = 48;
  const todayAndTomorrow = oneDay * 2;
  const hrsTimeShitf = maxTimeshift * 2;
  const limit = todayAndTomorrow + hrsTimeShitf;

  for (i; i < limit; i++) {
    const hour = `${m(schedule?.[i], HOUR_FORMAT_EPG)
      .add(30, 'minutes')
      .format('HH.mm')}hs.`;
    schedule.push(hour);
  }

  return schedule;
};

export const getWeightFromBegining = initialSchedule => {
  const dateFrom = m(initialSchedule, DATE_FORMAT_START_SCHEDULE_MIN);
  const diff = m().diff(dateFrom, 'minutes');
  return diff;
};

export const eventIsFocusable = ({ date_begin, date_end }) => {
  const dateFrom = m(date_begin, EVENT_CARD_FORMAT_TIME_EPG, true);
  const dateTo = m(date_end, EVENT_CARD_FORMAT_TIME_EPG, true);
  return m().isBetween(dateFrom, dateTo);
};

export const eventIsStillAvailable = (date_end, maxTimeShift) => {
  const dateFrom = m().subtract(maxTimeShift, 'milliseconds');
  const dateTo = m();
  const eventDateTo = m(date_end, EVENT_CARD_FORMAT_TIME_EPG);
  return eventDateTo.isBetween(dateFrom, dateTo);
};

export const getInitialSchedule = timeshift => {
  const dateFrom = m().format(DATE_FORMAT_START_SCHEDULE);
  const diff = m().diff(dateFrom, 'minutes');
  if (timeshift > 0) {
    const limitRange = timeshift >= 24 ? 22 : timeshift;
    if (diff > 30)
      return m()
        .add(-1 * limitRange, 'hours')
        .format(DATE_FORMAT_AFTER_30_MINUTES);

    return m()
      .add(-1 * limitRange, 'hours')
      .format(DATE_FORMAT_BEFORE_30_MINUTES);
  }
  if (diff > 30) return m().format(DATE_FORMAT_AFTER_30_MINUTES);
  return m().format(DATE_FORMAT_BEFORE_30_MINUTES);
};

export const getEventSchedule = ({ name, date_begin, date_end }) => {
  const validTitle = name !== '' && name !== null;
  const dateFrom = m(date_begin, EVENT_CARD_FORMAT_TIME_EPG, true);
  const dateTo = m(date_end, EVENT_CARD_FORMAT_TIME_EPG, true);

  const start = m(dateFrom, DATE_FORMAT_START_SCHEDULE_MIN, true).format(
    'HH.mm',
  );
  const end = m(dateTo, DATE_FORMAT_START_SCHEDULE_MIN, true).format('HH.mm');
  const diff = dateFrom.preciseDiff(dateTo, true);
  const label = validTitle
    ? `${start}hs a ${end}hs   ${diff.hours}h ${diff.minutes}min`
    : `${start}hs a ${end}hs`;
  return label;
};

export const isFavoriteChannel = (channelId, favoriteChannels = []) =>
  favoriteChannels.some(channel => channel.id === channelId);

export const eventIsAllow = ({ date_begin, date_end }) => {
  const dateFrom = m(date_begin, EVENT_CARD_FORMAT_TIME_EPG, true);
  const dateTo = m(date_end, EVENT_CARD_FORMAT_TIME_EPG, true);
  if (m().isBetween(dateFrom, dateTo)) {
    return 'play';
  }
  if (m().isBefore(dateFrom)) {
    return 'after';
  }
  return 'before';
};

export const getEventTransmissionTime = ({ date_begin, date_end }) => {
  const now = m();
  const start = m(date_begin, EVENT_CARD_FORMAT_TIME_EPG, true);
  const end = m(date_end, EVENT_CARD_FORMAT_TIME_EPG, true);

  // Verificar si el evento está ocurriendo ahora
  if (now.isBetween(start, end)) {
    return 'today';
  }

  // Verificar si el evento ocurrirá en el futuro
  if (now.isBefore(start)) {
    if (start.isSame(now.clone().add(1, 'day'), 'day')) {
      return 'tomorrow';
    } else if (start.isAfter(now.clone().add(1, 'day'))) {
      return 'afterTomorrow';
    } else {
      return 'todayAfter';
    }
  }

  // Si el evento ya ocurrió
  if (now.isAfter(end)) {
    if (end.isSame(now.clone().subtract(1, 'day'), 'day')) {
      return 'yesterday';
    } else if (end.isBefore(now.clone().subtract(1, 'day'))) {
      return 'beforeYesterday';
    } else {
      return 'todayBefore';
    }
  }
  return 'otherDate';
};

export const getEventProgressPercentage = ({ date_begin, date_end }) => {
  const now = m();
  const start = m(date_begin, EVENT_CARD_FORMAT_TIME_EPG, true);
  const end = m(date_end, EVENT_CARD_FORMAT_TIME_EPG, true);

  // Verificar si el evento está ocurriendo ahora
  if (now.isBetween(start, end)) {
    const totalDuration = end.diff(start, 'milliseconds');
    const elapsedTime = now.diff(start, 'milliseconds');
    const progressPercentage = (elapsedTime / totalDuration) * 100;

    // Asegurarnos de que el porcentaje esté entre 0 y 100
    return Math.min(Math.max(progressPercentage, 0), 100);
  }

  // Si el evento no está en curso
  return null;
};

export const getRanges = timeshift => {
  const initialFormatHour = m()
    .add(-1 * timeshift, 'hours')
    .format(DATE_FORMAT_START_SCHEDULE);
  const initialFormat = m()
    .add(-1 * timeshift, 'hours')
    .format(DATE_FORMAT_START_RANGE);
  const initialHour = m(initialFormatHour, DATE_FORMAT_START_SCHEDULE, true);
  const initial = m(initialFormat, DATE_FORMAT_START_RANGE, true);
  const dateFromFormat = m().format(DATE_FORMAT_START_RANGE);
  const dateFrom = m(dateFromFormat, DATE_FORMAT_START_RANGE, true);
  const hoursYesterday = dateFrom.diff(initialHour, 'hours');
  const daysToNow = dateFrom.diff(initial, 'days');
  const limitHours = dateFrom.add(1, 'days');
  const hoursToday = limitHours.diff(initialHour, 'hours');
  const resp = {
    past: daysToNow > 0 ? hoursYesterday * 2 * 330 : 0,
    present:
      daysToNow > 0
        ? hoursYesterday * 2 * 330 + 48 * 330
        : hoursToday * 2 * 330,
  };
  return resp;
};
export const isChannelBlocked = (channelId, blockedChannels = []) =>
  blockedChannels?.some(channel => channel === channelId);

export const getLabels = state => {
  const {
    metadata: { translations = '' } = {},
    user: { region = 'mexico' } = {},
  } = state;

  return JSON.parse(translations).language[region];
};

export const addStyledEvent = (channelSelected, idAlfaEvent, eventPlaying) => {
  let index = '';
  let classSelected = '';

  if (channelSelected && idAlfaEvent === eventPlaying?.event_alf_id) {
    index = 'selected';
    classSelected = 'EPG__guide__item__selected';
  }

  return {
    index,
    classSelected,
  };
};

export const getIdChannelCurrenUrl = () => {
  try {
    const groupId = browserHistory
      ?.getCurrentLocation()
      ?.pathname?.split('/')?.[3];
    return groupId || '';
  } catch (error) {
    console.error(error);
    return '';
  }
};
